/**
 * Swaps a video facade for the real YouTube player on first click.
 *
 * The block renders a thumbnail and a play button rather than an iframe. An embedded YouTube player
 * pulls roughly a megabyte of script before anyone asks for it, on every product page, and it is
 * third-party script in the critical path — the facade costs one image and defers the rest to the
 * people who actually want to watch.
 *
 * Delegated from `document`, because Horizon re-renders the product details on variant change and
 * would discard listeners bound directly to the buttons.
 */
document.addEventListener('click', (event) => {
  const facade = event.target.closest('.pta-video__facade');
  if (!facade) return;

  const id = facade.dataset.videoId;
  if (!id) return;

  const frame = document.createElement('iframe');
  /* nocookie: YouTube's privacy-preserving host, which sets no tracking cookie until playback. */
  frame.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0`;
  frame.title = facade.getAttribute('aria-label') ?? '';
  frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
  frame.allowFullscreen = true;
  frame.loading = 'lazy';
  frame.className = 'pta-video__frame';

  facade.replaceWith(frame);
  /* The click that triggered the swap never reaches the player, so move focus for keyboard users. */
  frame.focus?.();
});
